module.exports = __webpack_public_path__ + "static/media/infochanges.a5e7fd88.png";